import type {
  CapabilityGrantResponse,
  OrganizationRoleChangeResponse,
  OrganizationRoleResponse,
} from "@kontextwerk/control-web-client"
import type { IdentityAdministrationApi } from "../../../../../../../../../../../../../api/kehrblatt/identity-administration"
import {
  runConfirmedChange,
  type ConfirmedChangeOutcome,
} from "../../../../../../../_shared/_logic/confirmed-change"

export type ReplaceRoleCommand = Readonly<{
  api: IdentityAdministrationApi
  /** The loaded role; its revision guards against concurrent changes. */
  role: OrganizationRoleResponse
  name: string
  /** Complete grant list: every catalog key exactly once. */
  grants: readonly CapabilityGrantResponse[]
}>

export type ReplaceRoleResult = ConfirmedChangeOutcome<OrganizationRoleChangeResponse>

/** Replaces name and grants of one own role; system roles are never sent. */
export const replaceRole = async ({
  api,
  role,
  name,
  grants,
}: ReplaceRoleCommand): Promise<ReplaceRoleResult> => {
  if (role.kind !== "custom") return { status: "forbidden" }

  return runConfirmedChange(
    {
      title: "Rolle speichern",
      description:
        "Die geänderten Berechtigungen gelten sofort für alle Benutzer mit dieser Rolle. Bitte bestätigen Sie die Änderung mit Ihrem aktuellen Passwort.",
      actionLabel: "Speichern",
      preserveParent: true,
    },
    () =>
      api.replaceRole(role.id, {
        name: name.trim(),
        grants: grants.map((grant) => ({ ...grant })),
        expected_revision: role.revision,
      }),
  )
}
